var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.item.type == 'accessMgmt' ? _c('is-fm-favaccessmgmt', {
    attrs: {
      "item": _vm.item,
      "tileSizeSetting": _vm.tileSizeSetting
    },
    on: {
      "invalid": function ($event) {
        return _vm.$emit('invalid');
      }
    }
  }) : _vm._e(), _vm.item.type == 'digitalTwin' ? _c('core-favdigitaltwin', {
    key: _vm.componentKey,
    attrs: {
      "item": _vm.item,
      "tileSizeSetting": _vm.tileSizeSetting
    },
    on: {
      "invalid": function ($event) {
        return _vm.$emit('invalid');
      }
    }
  }) : _vm._e(), _vm.item.type == 'createTicket' ? _c('core-fav-create-ticket', {
    attrs: {
      "item": _vm.item,
      "tileSizeSetting": _vm.tileSizeSetting
    },
    on: {
      "invalid": function ($event) {
        return _vm.$emit('invalid');
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };